import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
var pathnameListeners = [];
/**
 * Patches history.pushState and history.replaceState to inform the location listeners when they're called
 */

function installPatch() {
  installFuncPatch("pushState");
  installFuncPatch("replaceState");
} // Monkey patch when on browser


if (true) {
  installPatch();
}
/**
 * Patches the given history[funcName] function to inform the routers when they're called
 */


function installFuncPatch(funcName) {
  var history = window.history;
  var origFunc = history[funcName];
  history[funcName] = patch;

  function patch(_x, _x2, _x3) {
    return _patch.apply(this, arguments);
  }

  function _patch() {
    _patch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, title, url) {
      var originalPathname;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              originalPathname = document.location.pathname; // Forward requests to the native function, even if they came as a result from calling router.replace()
              // That way we ensure we don't lose any data that router may decide to set.

              origFunc.call(this, data, title, url);

              if (document.location.pathname !== originalPathname) {
                pathnameChanged(document.location.pathname);
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    return _patch.apply(this, arguments);
  }
}

export function subscribeToPathname(listener) {
  pathnameListeners.push(listener);
  return function () {
    pathnameListeners = pathnameListeners.filter(function (l) {
      return l !== listener;
    });
  };
}

function pathnameChanged(pathname) {
  pathnameListeners.forEach(function (listener) {
    try {
      listener(pathname);
    } catch (e) {
      console.log("Encountered error firing history changed event", e);
    }
  });
}